import $ from 'jquery';
import screenSize from './../../../common/screen_size_util';

/* this module affects the top winner styling, index-page */

module.exports = function () {
    $('.mic-list-companies__company-row').last().css('border-bottom', 0);
};
